module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"name":"Name","example":"The quick brown fox jumps over the lazy dog."}}')
  delete Component.options._Ctor
}
